export default __webpack_public_path__ + "static/media/uni.0c76e4d2.jpg";